import api from '../axios';

// 시공계약
// 계약 목록 조회 (필터 지원)
export const getContracts = (projectId, params = {}) =>
  api.get(`contract/construction_contract/${projectId}/`, { 
    params
  }).then(res => res.data);

// 계약 상세 조회
export const getContractDetail = (contractId) =>
  api.get(`contract/construction_contract/detail/${contractId}/`)
     .then(res => res.data);

// 계약 생성 (파일 포함 가능)
export const createContract = (data) =>
  api.post('contract/construction_contract/create/', data, {
    headers: { "Content-Type": "multipart/form-data" }
  }).then(res => res.data);

// 계약 수정 (파일 포함 가능)
export const updateContract = (contractId, data) =>
  api.put(`contract/construction_contract/update/${contractId}/`, data, {
    headers: { "Content-Type": "multipart/form-data" }
  }).then(res => res.data);

// 계약 삭제
export const deleteContract = (contractId) =>
  api.delete(`contract/construction_contract/delete/${contractId}/`)
     .then(res => res.data);